// frontend/src/api/services/auth.js
import sharedAuthApi from '@shared-library/api/services/authApi.js';

export default function(apiClient) {
  // 使用共享库中的认证API
  const sharedAuth = sharedAuthApi(apiClient);
  
  // 移除getUserMenus方法，因为前端不需要
  const { getUserMenus, ...filteredAuth } = sharedAuth;
  
  return {
    ...filteredAuth
  };
}